"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAROUSEL_DOCUMENTS_QUERY = void 0;
const client_1 = require("@apollo/client");
exports.CAROUSEL_DOCUMENTS_QUERY = (0, client_1.gql) `
  query getCarouselDocuments($propertyId: ID!, $filterHidden: Boolean!) {
    property(propertyId: $propertyId) {
      id
      streetViewEnabled
      coverImageDocumentUploadId
      documentUploads(
        filterHidden: $filterHidden
        filterProcessing: true
        carouselDocumentsOnly: true
      ) {
        id
        accountDocumentType {
          id
          name
        }
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q2Fyb3VzZWxEb2N1bWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0FkZHJlc3NQYW5lbC9Qcm9wZXJ0eU92ZXJ2aWV3L19fcXVlcmllc19fL2dldENhcm91c2VsRG9jdW1lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDJDQUFxQztBQUV4QixRQUFBLHdCQUF3QixHQUFHLElBQUEsWUFBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBbUIxQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZ3FsIH0gZnJvbSBcIkBhcG9sbG8vY2xpZW50XCI7XG5cbmV4cG9ydCBjb25zdCBDQVJPVVNFTF9ET0NVTUVOVFNfUVVFUlkgPSBncWxgXG4gIHF1ZXJ5IGdldENhcm91c2VsRG9jdW1lbnRzKCRwcm9wZXJ0eUlkOiBJRCEsICRmaWx0ZXJIaWRkZW46IEJvb2xlYW4hKSB7XG4gICAgcHJvcGVydHkocHJvcGVydHlJZDogJHByb3BlcnR5SWQpIHtcbiAgICAgIGlkXG4gICAgICBzdHJlZXRWaWV3RW5hYmxlZFxuICAgICAgY292ZXJJbWFnZURvY3VtZW50VXBsb2FkSWRcbiAgICAgIGRvY3VtZW50VXBsb2FkcyhcbiAgICAgICAgZmlsdGVySGlkZGVuOiAkZmlsdGVySGlkZGVuXG4gICAgICAgIGZpbHRlclByb2Nlc3Npbmc6IHRydWVcbiAgICAgICAgY2Fyb3VzZWxEb2N1bWVudHNPbmx5OiB0cnVlXG4gICAgICApIHtcbiAgICAgICAgaWRcbiAgICAgICAgYWNjb3VudERvY3VtZW50VHlwZSB7XG4gICAgICAgICAgaWRcbiAgICAgICAgICBuYW1lXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cbmA7XG4iXX0=